// Racket Lab Admin — Spanish base translations (i18n QUICK 1.A scaffolding).
//
// SCAFFOLDING ONLY. No JSX consumes this file yet — migration happens
// incrementally in QUICK 1.B-G under separate GOs.
//
// Tree structure mirrors `racketLab.en.js` 1:1. Adding a new key in en.js
// REQUIRES the same key here. Translations follow TEAM OS Spanish
// conventions: short, operative, no marketing fluff.
//
// HARD RULES (do not break):
//   1. Values may be plain strings only — no inline JSX.
//   2. Snake_case enum values (e.g. `shop_manager`) NEVER appear here as keys.
//   3. Order of keys mirrors en.js exactly (eases diff during translation review).
//   4. Keep button/badge strings short — they render in tight chrome.

const racketLabEs = {
  // SS-8/CP-1.3 — panel del guard de secciones RBAC.
  guard: {
    denied_title: "Sección no disponible",
    denied_body: "Tu perfil no tiene acceso a esta sección de la consola Racket Lab.",
    back_to_dashboard: "Volver al panel",
  },

  nav: {
    groups: {
      core: "Núcleo",
      workforce: "Equipo",
      qr_notifications: "QR y notificaciones",
      ops_toolkit: "Herramientas operativas",
    },
    items: {
      dashboard: "Panel",
      shops: "Tiendas",
      tickets: "Tickets",
      my_tickets: "Mis tickets",
      calendar: "Calendario",
      operators: "Operadores",
      shifts: "Turnos",
      capabilities: "Capacidades",
      inventory: "Inventario",
      qr_tokens: "Tokens QR",
      resolve: "Resolver",
      envelopes: "Sobres",
      mock_outbox: "Bandeja simulada",
      toolkit: "Herramientas",
      promote: "Promover",
      gating: "Gating",
      redis: "Redis",
      scan_audit: "Auditoría de escaneo",
      legacy: "Legacy",
      retention: "Retención",
      seed_helper: "Asistente de seeds",
    },
  },

  common: {
    actions: {
      cancel: "Cancelar",
      confirm: "Confirmar",
      apply: "Aplicar",
      save: "Guardar",
      close: "Cerrar",
      open: "Abrir",
      toggle: "Alternar",
      reset: "Restablecer",
      reveal: "Mostrar",
      hide: "Ocultar",
      copy: "Copiar",
      refresh: "Actualizar",
      submit: "Enviar",
      lookup: "Buscar",
      create: "Crear",
      verify: "Verificar",
      resolve: "Resolver",
      mint: "Emitir",
      load_into_promote: "Cargar en el formulario de promoción",
    },
    destructive: {
      revoke: "Revocar",
      permanently_destroy: "Destruir permanentemente",
      force_on: "Forzar activado",
      force_off: "Forzar desactivado",
      clear_override: "Quitar override",
      not_reversible: "NO reversible",
      type_to_confirm: "Escribe {phrase} para confirmar",
    },
    labels: {
      status: "Estado",
      country: "País",
      organisation: "Organización",
      shop: "Tienda",
      shop_id: "ID tienda",
      shop_ids: "IDs tienda",
      user: "Usuario",
      user_id: "ID usuario",
      role: "Rol",
      name: "Nombre",
      display_name: "Nombre visible",
      code: "Código",
      customer: "Cliente",
      created: "Creado",
      created_at: "Creado el",
      actions: "Acciones",
      result: "Resultado",
      reason: "Motivo",
      bucket: "Bucket",
      language: "Idioma",
      channel: "Canal",
      recipient: "Destinatario",
      dry_run: "Simulación",
      capability: "Capacidad",
      ttl: "TTL",
      single_use: "Uso único",
      kind: "Tipo",
      state: "Estado",
      expires_at: "Expira el",
      used_at: "Usado el",
      entity: "Entidad",
      scope: "Ámbito",
      revoke_reason: "Motivo de revocación",
      template_key: "Clave de plantilla",
      from_role: "Rol emisor",
      dispatch_ref: "Ref. de envío",
      dispatched_at: "Enviado el",
      label: "Etiqueta",
      notes: "Notas",
    },
    empty_state: "No hay elementos todavía.",
    unknown: "Desconocido",
    columns: {
      id: "ID",
    },
    filters: {
      any_option: "(cualquiera)",
    },
    list: {
      counter_items: "{count} elementos",
      counter_of_total: "{count} de {total}",
    },
  },

  dashboard: {
    title: "Panel",
    page_title: "Racket Lab · Panel de administración",
    page_subtitle: "Piloto: {org} · Sólo lectura · Track A",
    loading: "Cargando…",
    error_prefix: "Error",
    error_unknown: "desconocido",
    promotion_overview: "Resumen de promociones",
    totals_total: "Total",
    totals_active: "Activos",
    totals_roles: "Roles",
    dispatch_card_title: "Notificaciones · estado de envío",
    dispatch_outbox_line: "Bandeja: {count} · TTL: {days}d",
    redis_card_title: "Salud de Redis (R2)",
    redis_flag_label: "redis",
    redis_healthy: "saludable",
    redis_down: "caído/deshabilitado",
    redis_backend_line: "Backend: {backend}",
    legacy_card_title: "Membresías legacy (S9.1)",
    legacy_unknown_label: "Sin clasificar",
    legacy_classified_label: "Clasificadas",
    landing: {
      quick_actions_title: "Accesos rápidos",
      quick_new_ticket: "Nuevo ticket",
      quick_tickets: "Tickets",
      quick_my_tickets: "Mis tickets",
      quick_calendar: "Calendario",
      quick_calendar_soon: "SS-4 · próximamente",
      stat_tickets_total: "Tickets totales",
      stat_active_queue: "Cola activa",
      stat_in_progress: "En curso",
      stat_ready_for_pickup: "Listos para recoger",
      stat_operators_active: "Operadores activos",
      stat_shops_active: "Tiendas activas",
      stat_open_shifts: "Turnos abiertos",
      stat_pending_envelopes: "Sobres pendientes",
      stat_low_stock: "Artículos con stock bajo",
      scoped_banner: "Vista limitada a tu ámbito · perfil: {profile}",
      qa_note: "Tickets QA/test: {n} (excluidos de los contadores operativos)",
      queue_title: "Cola de trabajo",
      queue_empty: "No hay tickets activos.",
      recent_title: "Tickets recientes",
      recent_empty: "Aún no hay tickets.",
      recent_view_all: "Ver todos",
      tensions_title: "Tensiones más usadas por tienda",
      tensions_empty: "Aún no hay tensiones registradas (datos estructurados SS-2.1).",
      tensions_hint: "Resumen admin-only · basado en campos estructurados de encordado (SS-2.1).",
      agenda_title: "Agenda / calendario",
      agenda_open_shifts: "{count} turno(s) abiertos ahora",
      agenda_today_title: "Servicios de hoy",
      agenda_today_empty: "Sin servicios programados para hoy.",
      agenda_open_calendar: "Abrir calendario",
      agenda_calendar_placeholder: "El calendario admin (vista mes/día) llega en SS-4. Este bloque ya reserva su sitio.",
      ops_section_title: "Plataforma / Ops",
      catalog_title: "Catálogo consumido",
      catalog_products_available: "Productos disponibles en catálogo",
      catalog_brands_available: "Marcas disponibles en catálogo",
      catalog_tickets_linked: "Tickets vinculados a catálogo",
      catalog_inventory_linked: "Inventario vinculado a catálogo",
      catalog_hint: "Sólo lectura · fuente: Catalog Intelligence (CATALOG-4).",
      cp_cohort_title: "Cohorte Controlled-Production",
      cp_cohort_count: "{n} miembro(s) provisionado(s)",
      cp_cohort_open: "Abrir consola cohorte",
      cp_cohort_hint: "Sólo admin · superficie de provisión CP-1.2.",
    },
    cards: {
      shops_total: "Tiendas",
      tickets_total: "Tickets",
      operators_total: "Operadores",
      open_shifts: "Turnos abiertos",
      active_tokens: "Tokens QR activos",
      pending_envelopes: "Sobres pendientes",
    },
  },

  shops: {
    title: "Tiendas",
    page_header: "Equipo · Tiendas",
    counter: "{count} tienda · sólo lectura",
    counter_plural: "{count} tiendas · sólo lectura",
    empty: "Aún no hay tiendas registradas.",
    columns: {
      name: "Nombre",
      country: "País",
      organisation: "Organización",
      shop_id: "ID tienda",
      service_mode: "Modo de servicio",
    },
    service_mode: {
      tooltip: "Modo de servicio",
      in_shop: "en tienda",
      mobile: "móvil",
      hybrid: "híbrido",
    },
    detail: {
      title: "Detalle de tienda",
      subtitle: "Sólo lectura · Paneles futuros (máquinas · capacidades · operadores · turnos) llegan en Sub-sprint B",
      back: "Volver a tiendas",
      loading: "Cargando tienda {id}…",
      not_found: "Tienda {id} no encontrada.",
      created_at: "Creado",
      status: "Estado",
      tension_preset: {
        title: "Preset de tensión por defecto",
        admin_only: "Sólo admin · staff",
        hint: "Opcional. Cuando está configurado, los nuevos tickets creados para esta tienda autorrellenan estos valores si el operador deja vacíos los campos de tensión. La edición manual siempre prevalece.",
        empty: "Aún no hay preset configurado para esta tienda.",
        unit: "Unidad",
        main: "Vertical (main)",
        cross: "Horizontal (cross)",
        save: "Guardar preset",
        saving: "Guardando…",
        clear: "Borrar preset",
      },
      low_stock_threshold: {
        title: "Umbral de stock bajo por defecto (fallback)",
        admin_only: "Sólo admin · staff",
        hint: "Opcional. Actúa como fallback A NIVEL TIENDA para los ítems que no tengan su propio umbral de stock bajo. Los ítems con umbral propio no se ven afectados.",
        empty: "No hay fallback de tienda configurado.",
        value: "Umbral (cantidad)",
        save: "Guardar umbral",
        saving: "Guardando…",
        clear: "Borrar umbral",
      },
      service_mode_section_title: "Modo de servicio · solicitud de cambio",
      request_change_btn: "Solicitar cambio de settings",
      request_change_hint: "shop_manager puede enviar una solicitud aquí; admin/staff la revisan y aplican manualmente vía PATCH /shops/{id}. CERO notificaciones reales.",
      request_change_placeholder: "Describe el cambio deseado…",
      cancel: "Cancelar",
      submit_request: "Enviar solicitud",
      submitting: "Enviando…",
      requests_history: "Solicitudes de esta tienda",
      requests_empty: "Aún no hay solicitudes.",
      loading_list: "Cargando…",
      decision_reason: "Decisión",
      approve: "Aprobar",
      reject: "Rechazar",
      cancel_request: "Cancelar solicitud",
      req_status_pending: "pendiente",
      req_status_approved: "aprobada",
      req_status_rejected: "rechazada",
      req_status_cancelled: "cancelada",
    },
  },

  tickets: {
    title: "Tickets",
    qa_badge: "QA prueba",
    counter: "{count} ticket · sólo lectura",
    counter_plural: "{count} tickets · sólo lectura",
    empty: "Aún no hay tickets registrados.",
    new_button: "Nuevo ticket",
    columns: {
      code: "Código",
      status: "Estado",
      shop: "Tienda",
      customer: "Cliente",
      created: "Creado",
    },
    detail: {
      title: "Detalle del ticket",
      subtitle: "Ciclo de vida vía endpoints por acción · Línea de tiempo abajo",
      back: "Volver a tickets",
      loading: "Cargando ticket…",
      not_found: "Ticket {id} no encontrado.",
      ticket_id: "ID ticket",
      customer_demo: "Cliente (demo)",
      racket: "Raqueta",
      player_synthetic: "ID jugador (sintético)",
      notes: "Notas",
      stringing_title: "Encordado · Racket Lab",
      product_type: "Tipo de material",
      brand: "Marca",
      model: "Modelo",
      accessory: "Complemento / accesorio",
      string_main: "Cordaje vertical",
      string_cross: "Cordaje horizontal",
      tension: "Tensión (vert / horiz)",
      string_origin: "Origen del cordaje",
      supply_format: "Formato aportado",
      customer_string_notes: "Notas material cliente",
      profile_type: "Perfil / contexto",
      inventory_item: "Inventario (set/bobina)",
      inventory_consumption: "Consumo de inventario",
      inventory_consumed: "consumido",
      inventory_not_consumed: "sin consumo registrado",
      scheduled_for: "Programado para",
    },
    stepper: {
      current_status: "Estado actual",
    },
    create: {
      title: "Nuevo ticket · admin-only",
      close: "Cerrar",
      cancel: "Cancelar",
      submit: "Crear ticket",
      submitting: "Creando…",
      error_unknown: "Error desconocido al crear el ticket.",
      gear3: {
        title: "Sugerido desde Mi Equipación",
        preview_badge: "preview · mock",
        toggle: "Mostrar datos seed mock",
        banner: "Solo preview · sin datos de cliente · sin escrituras en DB · sin ConsentGate · sin notificaciones reales · sin oferta de marketplace.",
        apply: "Aplicar sugerencia de Mi Equipación",
        disabled_hint: "Activa el toggle para cargar 3 raquetas mock (Racket 1 default / Racket 2 / Racket 3 · pending canonical). Las sugerencias solo rellenan campos vacíos — manual override, shop preset y operator preset siempre ganan.",
        report: {
          title: "Sugerencia aplicada (solo local · no enviado)",
          filled: "Rellenados",
          preserved: "Preservados (manual / shop / operator preset ya activos)",
          hierarchy_note: "Jerarquía: manual override > perfil customer/racket > shop preset > operator preset > vacío.",
        },
      },
      shop_label: "Tienda *",
      shop_placeholder: "Selecciona una tienda…",
      capability_label: "Capability *",
      capability_placeholder: "Selecciona un servicio…",
      equipment_label: "Etiqueta del material *",
      equipment_placeholder: "Ej. raqueta-X1 / encordado set 16x19",
      customer_label: "Etiqueta del cliente",
      customer_placeholder: "Ej. cliente-demo-Q26 (sin PII)",
      notes_label: "Notas del equipo",
      notes_placeholder: "Estado de la raqueta, marca de cuerda, tensión preferida…",
      operator_label: "Operador (opcional)",
      operator_placeholder: "racket_lab_operator_id",
      operator_hint: "Si se rellena, el ticket nace en estado 'assigned'.",
      operator_pick_shop_first: "Selecciona primero una tienda",
      operator_empty_shop: "No hay operadores activos en esta tienda",
      operator_unassigned: "— Sin asignar —",
      operator_placeholder_tag: "placeholder",
      operator_use_manual: "Usar UUID manual",
      operator_use_select: "Usar selector por tienda",
      operator_search_placeholder: "Busca operadores por nombre…",
      operator_loading: "Buscando…",
      operator_no_results: "Ningún operador coincide con la búsqueda",
      operator_clear: "Borrar operador",
      machine_label: "Máquina (opcional)",
      machine_placeholder: "racket_lab_machine_id",
      anti_pii_hint: "Sin emails ni teléfonos · backend rechaza '@' y 7+ dígitos.",
      initial_status_hint_draft: "Estado inicial: draft",
      initial_status_hint_assigned: "Estado inicial: assigned (con operador)",
      section_product_title: "Producto / material",
      section_stringing_title: "Encordado",
      section_context_title: "Contexto",
      catalog_mock_hint: "Raquetas y cordajes de tenis ahora provienen del catálogo central (Catalog Intelligence, solo lectura). Pádel/otros siguen usando el mock temporal · entrada manual siempre disponible.",
      string_catalog_label: "Desde catálogo central (opcional)",
      string_catalog_placeholder: "— Seleccionar cordaje del catálogo —",
      product_type_label: "Tipo de material",
      product_type_placeholder: "Selecciona tipo…",
      brand_label: "Marca",
      brand_placeholder: "Selecciona marca…",
      brand_custom_label: "Marca (texto libre)",
      brand_custom_placeholder: "Escribe la marca…",
      model_label: "Modelo",
      model_placeholder: "Selecciona modelo…",
      model_custom_label: "Modelo (texto libre)",
      model_custom_placeholder: "Escribe el modelo…",
      option_other: "Otro…",
      accessory_label: "Complemento / accesorio",
      accessory_placeholder: "Ej. grip, protector, antivibrador…",
      string_main_label: "Cordaje vertical",
      string_main_placeholder: "Ej. Babolat RPM Blast",
      string_cross_label: "Cordaje horizontal",
      string_cross_placeholder: "Igual o distinto al vertical",
      string_copy_main: "= vertical",
      tension_main_label: "Tensión vertical",
      tension_cross_label: "Tensión horizontal",
      tension_unit_label: "Unidad",
      tension_placeholder: "1–80",
      tension_preset_banner: "Preset de tensión aplicado desde la tienda seleccionada. Puedes sobreescribir cualquier valor manualmente.",
      tension_preset_banner_operator: "Preset de tensión aplicado desde el operador/técnico seleccionado en los campos que quedaban vacíos. Puedes sobreescribir cualquier valor manualmente.",
      string_origin_label: "Origen del cordaje",
      string_origin_placeholder: "Selecciona origen…",
      supply_format_label: "Formato del cordaje propio",
      supply_format_placeholder: "Set o bobina…",
      customer_string_notes_label: "Notas del material del cliente",
      customer_string_notes_placeholder: "Estado del set/bobina aportado por el cliente…",
      profile_type_label: "Perfil / contexto del usuario",
      profile_type_placeholder: "Selecciona perfil…",
      profile_type_hint: "Sólo diseño admin-only · sin efectos customer-facing.",
      scheduled_label: "Fecha programada (opcional)",
      scheduled_hint: "Aparece en el calendario admin (SS-4).",
      inventory_item_label: "Inventario de tienda (set/bobina)",
      inventory_item_placeholder: "Vincular artículo de inventario… (opcional)",
      inventory_item_hint: "Solo referencia · el stock NO se descuenta automáticamente (SS-6.1).",
    },
    stringing: {
      product_type_racket: "Raqueta (tenis)",
      product_type_padel_racket: "Pala (pádel)",
      product_type_accessory: "Accesorio",
      product_type_other: "Otro",
      origin_shop: "Cordaje de tienda",
      origin_customer: "Cordaje propio del cliente",
      supply_set: "Set",
      supply_reel: "Bobina / carrete",
      profile_player: "Jugador",
      profile_parent_guardian: "Padre / Madre / Tutor",
      profile_coach: "Coach",
      profile_stringer: "Técnico / stringer",
      profile_shop_operator: "Operador / tienda",
      profile_admin_staff: "Admin / staff",
    },
    qr_canonical: {
      title: "QR canónico del ticket",
      subtitle: "Admin-only · sin scan público · trazabilidad vía qr_tokens",
      loading: "Cargando QR…",
      none: "Este ticket aún no tiene QR canónico.",
      generate: "Generar QR canónico",
      generating: "Generando…",
      payload_label: "Payload",
      expires_label: "Expira",
      scan_count_label: "Escaneos",
      print_view: "Vista de impresión",
      print: {
        title: "Ticket Racket Lab · QR",
        print_btn: "Imprimir",
        back: "Volver al ticket",
        status_label: "Estado",
        customer_label: "Cliente",
        equipment_label: "Material",
        strings_label: "Cordaje (V/H)",
        tension_label: "Tensión",
        scheduled_label: "Programado",
        shop_label: "Tienda",
        operator_label: "Operador",
        not_found: "QR no encontrado. Genera el QR canónico desde el detalle del ticket.",
      },
    },
    photos: {
      title: "Fotos del material",
      subtitle: "Evidencia visual admin-only · storage privado · URLs firmadas (5 min) · borrado lógico",
      loading: "Cargando fotos…",
      empty: "Este ticket aún no tiene fotos.",
      upload_btn: "Subir foto",
      uploading: "Subiendo…",
      upload_hint: "JPEG/PNG/WebP/HEIC · máx 8MB · máx 20 fotos por ticket",
      caption_placeholder: "Descripción breve (opcional)…",
      phase_check_in: "Check-in",
      phase_in_service: "Durante servicio",
      phase_final: "Final",
      phase_pickup: "Entrega",
      delete_btn: "Eliminar (borrado lógico)",
      delete_confirm: "¿Eliminar esta foto? (borrado lógico, recuperable por admin)",
      print_label: "Evidencia fotográfica",
      print_count: "{count} foto(s) registradas",
    },
    qa: {
      title: "Cómo lo verás como QA tester",
      step_1: "Pulsa 'Nuevo ticket' en la esquina superior derecha.",
      step_2: "Selecciona Tienda + Capability (ambos requeridos).",
      step_3: "Escribe una 'Etiqueta del material' descriptiva (sin email ni teléfono).",
      step_4: "Opcional: rellena cliente / operador / máquina / notas.",
      step_5: "Pulsa 'Crear ticket'. La consola te redirige al detalle.",
      step_6: "Comprueba el estado inicial: 'draft' sin operador · 'assigned' si lo añadiste.",
      step_7: "Verifica que el Stepper muestra las acciones permitidas correctas para ese estado.",
      pass_label: "PASS",
      pass_criteria: "Ticket creado · status inicial coherente · Stepper con acciones esperadas · audit timeline visible.",
      fail_label: "FAIL",
      fail_criteria: "422 sin razón clara · status inicial incorrecto · Stepper vacío en estado no terminal · timeline no renderiza.",
      cta_open_new: "Abrir 'Nuevo ticket' ahora",
    },
  },
  my_tickets: {
    title: "Mis tickets",
    subtitle: "Cola de trabajo del operador · admin-only · preview-first",
    operator_label: "Operador",
    operator_placeholder: "Selecciona un operador…",
    no_operator_selected: "Selecciona un operador para ver su cola.",
    counter: "{count} ticket(s) activos",
    include_terminal_label: "Incluir terminales (closed/cancelled/deleted)",
    loading: "Cargando tickets…",
    empty_no_operator: "Aún no se ha seleccionado operador. Elige uno en el selector de arriba para ver su cola de tickets.",
    empty_for_operator: "Este operador no tiene tickets en los estados visibles. Activa 'Incluir terminales' para ver el histórico.",
    low_stock_badge: "Stock bajo",
    insufficient_stock_badge: "Stock insuficiente",
    stock_hint: "{available} {unit} disponibles · {needed} necesarios por ticket",
  },

  calendar: {
    title: "Calendario",
    subtitle: "Agenda admin-only · tickets programados + turnos · preview-first",
    today: "Hoy",
    loading: "Cargando calendario…",
    filter_all_shops: "Todas las tiendas",
    filter_all_operators: "Todos los operadores",
    totals_line: "{tickets} ticket(s) programados · {shifts} turno(s) · {unscheduled} sin programar",
    weekdays: { mon: "L", tue: "M", wed: "X", thu: "J", fri: "V", sat: "S", sun: "D" },
    shift_chip: "{count} turno(s)",
    day_panel_title: "Día {date}",
    day_panel_empty: "Sin tickets ni turnos este día.",
    tickets_label: "Tickets",
    shifts_label: "Turnos",
    unscheduled_title: "Tickets sin programar (activos)",
    unscheduled_empty: "No hay tickets activos sin programar.",
    unscheduled_hint: "Programar reutiliza el PATCH existente de tickets · sin endpoints nuevos de escritura.",
    schedule_btn: "Programar",
  },

  operators: {
    title: "Operadores",
    page_header: "Equipo · Operadores",
    counter: "{count} operador",
    counter_plural: "{count} operadores",
    empty: "Aún no hay operadores.",
    invite_submit: "Invitar operador",
    placeholder_user_id: "user_id (usuario TEAM existente)",
    placeholder_label: "etiqueta visible",
    placeholder_org: "organisation_id",
    columns: {
      label: "Etiqueta",
      user: "Usuario",
      status: "Estado",
      user_link_status: "Vínculo",
      tension_preset: "Preset tensión",
      actions: "Acciones",
    },
    status_active: "activo",
    status_inactive: "inactivo",
    user_link_status: {
      filter_label: "Filtro vínculo",
      filter_all: "Todos",
      linked: "vinculado",
      orphan_review: "huérfano · revisar",
      orphan_safe: "huérfano · seguro",
    },
    toggle_btn: "Alternar estado",
    toggle_title: "¿Alternar estado del operador?",
    toggle_description: "Cambiar {label} de {from} a {to}.",
    toggle_confirm_label: "Alternar",
    tension_preset: {
      title: "Preset de tensión personal",
      admin_only: "Sólo admin · staff",
      hint: "Opcional. Actúa como SUGERENCIA OPERATIVA cuando no aplique preset de tienda. Jerarquía: 1) edición manual · 2) cliente/perfil/QR (futuro, BLOQUEADO) · 3) preset de tienda · 4) preset del operador · 5) vacío. La edición manual y el preset de tienda siempre prevalecen.",
      empty: "No hay preset personal configurado.",
      summary_empty: "—",
      unit: "Unidad",
      main: "Vertical (main)",
      cross: "Horizontal (cross)",
      save: "Guardar preset",
      saving: "Guardando…",
      clear: "Borrar preset",
      cancel: "Cancelar",
    },
    resnapshot: {
      title: "Re-snapshot de tokens de búsqueda del usuario vinculado",
      subtitle: "Sólo admin · staff. Refresca los snapshots de email y nombre del operador contra la colección de usuarios actual. Dry-run primero; el apply requiere confirmación escrita.",
      locked_notice: "Bloqueado — sólo admin/staff.",
      shop_filter_label: "Tienda (opcional)",
      shop_filter_all: "Todas las tiendas",
      dry_run_btn: "Ejecutar dry-run",
      running: "Ejecutando…",
      empty: "Ejecuta un dry-run para ver cuántos snapshots de operador necesitan refrescarse.",
      totals_reviewed: "revisados",
      totals_would_update: "se actualizarían",
      totals_unchanged: "sin cambios",
      totals_no_user_id: "sin user_id",
      totals_user_not_found: "usuario no encontrado",
      totals_errors: "errores",
      totals_applied: "aplicados",
      bucket_would_update: "Se actualizarían ({count})",
      bucket_user_not_found: "Usuario no encontrado ({count})",
      bucket_user_not_found_hint: "Estos operadores tienen un user_id que ya no resuelve a un usuario. Los snapshots se preservan a propósito; la política (mantener / borrar / suspender) es un slice aparte.",
      diff_before: "Antes",
      diff_after: "Después",
      diff_truncated: "Mostrando {shown} de {total} entradas; afina el filtro de tienda para reducir.",
      apply_explain: "El apply refrescará {count} snapshot(s) de operador. Sólo escribe linked_user_email_snapshot y linked_user_display_name_snapshot, nunca user_id, display_label, tickets, inventario, tiendas ni usuarios.",
      apply_confirm_label: "Escribe {word} para confirmar",
      apply_btn: "Aplicar re-snapshot",
      apply_result: "Apply completado. Operadores refrescados: {count}.",
      no_pending: "Nada que refrescar — todos los snapshots ya coinciden.",
    },
  },

  shifts: {
    title: "Turnos",
    page_header: "Equipo · Turnos",
    counter: "{count} turno",
    counter_plural: "{count} turnos",
    empty: "Aún no hay turnos.",
    subtitle: "Superficie read-only-first. Los turnos vienen del pilot seed (POST /api/admin/racket-lab/_ops/pilot-seed) o del formulario de creación futuro (Sub-sprint B+).",
    columns: {
      shift: "Turno",
      shop: "Tienda",
      starts: "Comienza",
      status: "Estado",
      actions: "Acciones",
    },
    action_open: "Abrir",
    action_close: "Cerrar",
    action_cancel: "Cancelar",
    dialog_open_title: "¿Abrir turno?",
    dialog_close_title: "¿Cerrar turno?",
    dialog_cancel_title: "¿Cancelar turno?",
  },

  capabilities: {
    title: "Capacidades",
    page_header: "Equipo · Capacidades",
    subtitle: "Catálogo (cross-org) y asignaciones por tienda",
    catalogue_section_title: "Catálogo (sólo lectura)",
    shopcap_section_title: "Capacidades por tienda",
    empty_catalogue: "No hay entradas en el catálogo de capacidades.",
    empty_shopcap: "No hay capacidades asignadas a tiendas.",
    columns: {
      key: "Clave",
      display_name: "Nombre visible",
      status: "Estado",
      shop: "Tienda",
      capability: "Capacidad",
      actions: "Acciones",
    },
    toggle_btn: "Alternar estado",
    toggle_title: "¿Alternar capacidad de la tienda?",
    toggle_confirm_label: "Alternar",
  },

  qr_tokens: {
    list_title: "Tokens QR",
    page_header: "QR · Tokens",
    counter: "{count} token",
    counter_plural: "{count} tokens",
    empty: "Aún no se han emitido tokens QR.",
    columns: { id: "ID", kind: "Tipo", state: "Estado", entity: "Entidad", scope: "Ámbito", expires: "Expira", organisation: "Organización" },
    mint: {
      title: "Emitir token QR (piloto Track A)",
      submit: "Emitir",
      kind_label: "Tipo",
      ttl_label: "TTL (s)",
      single_use_label: "Uso único",
      entity_label: "Entidad",
      org_label: "Organización",
      scope_label: "Ámbito",
      org_label_locked: "Organización (bloqueada al piloto)",
      entity_label_optional: "ID de entidad (opcional)",
      entity_placeholder: "id de ticket, id de tienda, …",
      ttl_label_optional: "TTL en segundos (opcional, valor por defecto según tipo)",
      ttl_placeholder: "déjalo vacío para el valor por defecto",
      footer_note: "Emisión interna de admin · sin imagen QR · token en bruto nunca registrado · solo Track A.",
    },
    revoke: {
      title: "Revocar token QR",
      submit: "Revocar",
      reason_label: "Motivo",
      reason_placeholder: "Motivo opcional de revocación",
      subtitle: "Solo revocación lógica. La eliminación física no se expone. Idempotente: una segunda revocación no tiene efecto.",
      reason_label_required: "Motivo (obligatorio, mín. 3 caracteres)",
      cancel_label: "Cancelar",
    },
    detail: {
      title: "Detalle del token QR",
      back: "Volver a tokens",
      loading: "Cargando token…",
      not_found: "Token {id} no encontrado.",
      state_revoked: "revocado",
      state_active: "activo",
      subtitle: "Token en bruto solo se revela bajo demanda · scan_audit añadido al resolver",
      back_label: "Volver a tokens QR",
      error_prefix: "Error",
      error_unknown: "desconocido",
      fields: {
        id: "ID",
        kind: "Tipo",
        state: "Estado",
        expires_at: "Expira",
        single_use: "Uso único",
        used_at: "Usado",
        organisation: "Organización",
        entity: "Entidad",
        scope: "Ámbito",
        revoke_reason: "Motivo de revocación",
      },
      raw_section: {
        title: "Valor del token en bruto",
        subtitle: "Visible solo bajo demanda · NUNCA registrado · política de copia única",
        reveal: "Mostrar",
        hide: "Ocultar",
      },
      revoke_btn: "Revocar token",
      audit_timeline_title: "Línea de tiempo de auditoría",
      scan_audit_timeline_title: "Línea de tiempo de auditoría de escaneo",
      raw_document_title: "Documento en bruto",
    },
    resolve: {
      title: "Resolver token",
      token_required: "El valor del token es obligatorio",
    },
  },

  notifications: {
    envelopes: {
      list_title: "Sobres",
      page_header: "Notificaciones · Sobres",
      counter: "{count} sobre",
      counter_plural: "{count} sobres",
      empty: "Aún no hay sobres.",
      create_title: "Crear borrador de sobre",
      detail_title: "Detalle del sobre",
      back: "Volver a sobres",
      loading: "Cargando sobre…",
      not_found: "Sobre {id} no encontrado.",
      columns: { id: "ID", template: "Plantilla", channel: "Canal", state: "Estado", to_role: "Rol destinatario", recipient: "Destinatario", created: "Creado", ticket: "Ticket" },
      filter_template_placeholder: "p. ej. racketLab.email.ready_for_pickup",
      filter_ticket_placeholder: "id de ticket",
      origin_auto: "auto",
      detail: {
        subtitle: "Máquina de estados lógica · dispatch-mock solo simulado · sin llamada real al proveedor",
        error_prefix: "Error",
        error_unknown: "desconocido",
        fields: {
          id: "ID",
          status: "Estado",
          template: "Plantilla",
          channel: "Canal",
          recipient: "Destinatario",
          language: "Idioma",
          from_role: "Desde rol",
          org: "Organización",
          ticket: "Ticket",
          dry_run: "Dry run",
          dispatch_ref: "Ref. de envío",
          dispatched_at: "Enviado",
          last_error: "Último error",
        },
        actions: {
          queue_btn: "Transición → en cola",
          queue_title: "Transicionar sobre a en cola",
          queue_description: "Sin llamada real al proveedor. Solo máquina de estados.",
          queue_confirm: "Encolar",
          cancel_btn: "Cancelar",
          cancel_title: "Cancelar sobre",
          cancel_description: "Estado terminal. Sin más transiciones.",
          cancel_confirm: "Cancelar sobre",
          preview_btn: "Vista previa (render dry-run)",
          dispatch_btn: "Envío (simulado)",
          dispatch_title: "Envío mediante adaptador simulado",
          dispatch_description: "SOLO SIMULADO · cero correos · sin llamada al proveedor · Q28 real OFF · dispatch real OFF · Captura el sobre en notifications_mock_outbox.",
          dispatch_confirm: "Envío (simulado)",
        },
        preview_title: "Vista previa (dry-run · no persistida)",
        audit_timeline_title: "Línea de tiempo de auditoría",
        raw_document_title: "Documento en bruto",
      },
      form: {
        template_label: "Clave de plantilla",
        channel_label: "Canal (derivado)",
        recipient_label: "user_id del destinatario",
        recipient_placeholder: "uuid del destinatario (usuario piloto interno)",
        language_label: "Idioma",
        from_role_label: "Desde rol",
        footer_note: "Siempre empieza como borrador · dry_run HARD true · SIN envío real.",
      },
    },
    mock_outbox: {
      list_title: "Bandeja simulada",
      page_header: "Notificaciones · Bandeja simulada",
      counter: "{count} elemento",
      counter_plural: "{count} elementos",
      empty: "Aún no hay elementos en la bandeja simulada.",
      item_title: "Elemento de bandeja simulada",
      back: "Volver a la bandeja simulada",
      loading: "Cargando elemento…",
      not_found: "Elemento {id} no encontrado.",
      columns: { id: "ID", template: "Plantilla", channel: "Canal", to_role: "Rol destinatario", result: "Resultado", envelope: "Sobre", captured_at: "Capturado", created: "Creado" },
      subtitle: "Solo capturado · sin llamada al proveedor · TTL gobernado por env (90d por defecto)",
      filter_template_placeholder: "racketLab.email.ready_for_pickup",
      item: {
        subtitle: "Solo capturado · cero proveedor real · cero correos",
        error_prefix: "Error",
        error_unknown: "desconocido",
        fields: {
          id: "ID",
          provider: "Proveedor",
          result: "Resultado",
          envelope_id: "ID del sobre",
          template: "Plantilla",
          channel: "Canal",
          captured_at: "Capturado",
          captured_by: "Capturado por",
          recipient_hash: "Hash del destinatario",
          redacted_reason: "Motivo de redacción",
        },
        captured_payload_title: "Carga capturada",
      },
    },
  },

  resolve: {
    page_header: "QR · Visor de resolución",
    subtitle: "Pega un token QR para inspeccionar su estado actual. Sin efectos de escritura.",
    token_label: "Token",
    token_placeholder: "qr_xxxxxxxxxx",
    submit: "Resolver",
    loading: "Resolviendo…",
    error_required: "El valor del token es obligatorio",
    error_not_found: "Token no encontrado o revocado.",
    result_title: "Token resuelto",
    no_result: "Pega un token arriba para empezar.",
  },

  ops: {
    toolkit: {
      title: "Herramientas operativas",
      sections: {
        promote: "Promover membresía",
        gating: "Gating de membresía",
        scan_audit: "Resumen de auditoría de escaneo",
        seed_helper: "Asistente de seeds de membresía",
      },
      page_subtitle: "Alcance D-α · solo admin / staff · contrato dry-run → apply obligatorio · solo piloto Track A",
      scope_badge: "TEAMSOFTWAREINNOVATIONS solo interno",
      complete_title: "Herramientas operativas completas (D-α + D-β-α + D-β-β).",
      complete_body: "Todos los endpoints de admin catalogados en el análisis D son alcanzables desde el shell de admin.",
      tiles: {
        promote: {
          title: "Promover membresía",
          body: "Promote S6 idempotente · dry-run + confirmation_token HMAC · revocable lógico",
        },
        gating: {
          title: "Gating de membresía",
          body: "Override en memoria (ON / OFF / borrar) · estado de env visible · se reinicia al reiniciar",
        },
        redis: {
          title: "Salud de rate-limit y envío",
          body: "Salud del backend Redis · estado de envío NP-R1 · reinicio de rate-limit (T1)",
        },
        scan_audit: {
          title: "Resumen de auditoría de escaneo",
          body: "Agregados sobre scan_audit[] · denegaciones pre-lookup · ventanas 24h / 7d / total",
        },
        legacy: {
          title: "Backfill legacy (S9.1)",
          body: "Resumen · clasificar uno (T2) · aplicar en lote (T3) · visor de informe de ejecución",
        },
        retention: {
          title: "Purgas de retención (T3)",
          body: "Denegaciones pre-lookup QR · bandeja simulada NP-R1 · irreversible · dry-run obligatorio",
        },
        seed_helper: {
          title: "Asistente de seeds de membresía",
          body: "Solo lectura · deriva intenciones de promote del último seed piloto · solo Cargar-en-Promote por fila",
        },
      },
    },
    common: {
      back_to_toolkit: "Volver a Herramientas operativas",
      error_prefix: "Error",
      error_unknown: "desconocido",
      in_flight: "en curso",
      in_flight_ellipsis: "en curso…",
      run_dry_run_first: "Ejecuta primero el dry-run",
      input_changed_rerun: "La entrada cambió · vuelve a ejecutar el dry-run",
      kill_switch_blocked: "kill_switch_active=true",
      reason_min_3: "El motivo debe tener ≥3 caracteres",
    },
    promote: {
      title: "Promover membresía",
      apply: "Aplicar promoción",
      rollback_apply: "Aplicar rollback",
      title_full: "Promover membresía (S6)",
      subtitle: "Idempotente · `confirmation_token` HMAC requerido · revocable lógico · solo Track A",
      intent_title: "Intención",
      prefill_banner: "Precargado desde {source} · Dry-run sigue requerido",
      dry_run_btn: "Dry-run",
      reset_btn: "Reiniciar",
      applied_line: "Aplicado · acción={action} · a {at}",
      stats: {
        memberships: "memberships",
        active: "active",
        revoked: "revoked",
        pending_onboarding: "pending_onboarding",
        audit_recent: "audit_recent",
      },
      form: {
        user_id_label: "ID de usuario",
        user_id_placeholder: "uuid del usuario objetivo",
        role_label: "Rol",
        role_hint: "Solo roles de runtime permitidos. Los roles reservados customer / guardian / sponsor están bloqueados en backend.",
        org_label_locked: "ID de organización (bloqueado al piloto)",
        shop_ids_label: "IDs de tienda (uno por línea, opcional)",
        footer_note: "Solo piloto interno · Track A · TEAMSOFTWAREINNOVATIONS · idempotente · revocable lógico.",
      },
    },
    rollback: {
      section_title: "Intención de rollback (revocación lógica)",
      dry_run_btn: "Dry-run de rollback",
      rolled_back_line: "Rollback aplicado · acción={action} · a {at}",
      form: {
        user_id_label: "ID de usuario (objetivo)",
        user_id_placeholder: "uuid del usuario a revertir",
        reason_label: "Motivo",
        reason_placeholder: "Motivo (mín. 3 caracteres · guardado en auditoría)",
        reason_short: "El motivo debe tener al menos 3 caracteres.",
        footer_note: "Solo revocación lógica · status → revoked · entrada de auditoría añadida · reversible vía promote.",
      },
    },
    verify: {
      title: "Verificar membresía",
      user_id_label: "ID de usuario",
      user_id_placeholder: "uuid",
      role_label_optional: "Rol (opcional)",
      role_placeholder: "p. ej. shop_manager",
      submit: "Verificar",
      user_id_required: "user_id requerido",
    },
    audit_viewer: {
      user_id_label: "ID de usuario",
      user_id_placeholder: "uuid",
      submit: "Buscar",
      user_id_required: "user_id requerido",
    },
    dry_run: {
      empty: 'Aún no hay dry-run. Rellena el formulario y pulsa "Dry-run".',
      stale_pill: "obsoleto · vuelve a ejecutar el dry-run",
      killswitch_banner: "kill_switch_active=true — `RL_PROMOTION_DRY_RUN` está activo en env. Apply queda deshabilitado pese al confirmation_token.",
      token_label: "confirmation_token (enmascarado):",
    },
    apply_strip: {
      type_to_enable: "Escribe {phrase} para habilitar el botón de aplicar.",
    },
    gating: {
      force_on: {
        title: "Forzar gating activado",
        description: "Activa el gating de membresía para todo el proceso. Se restablece al reiniciar.",
        confirm: "Forzar activado",
      },
      force_off: {
        title: "Forzar gating desactivado",
        description: "Desactiva el gating de membresía para todo el proceso. Usar con precaución. Se restablece al reiniciar.",
        confirm: "Forzar desactivado",
      },
      clear_override: {
        title: "Quitar override de gating",
        description: "Vuelve a la flag del entorno. Sin mutación de env. Sin reinicio.",
        confirm: "Quitar override",
      },
      page_title: "Override de gating de membresía",
      subtitle: "Solo admin · en memoria · nunca muta env · se reinicia al reiniciar el proceso",
      loading: "Cargando estado de gating…",
      current_state: "Estado actual",
      current_state_hint: "env_flag · override · effective",
      override_active: "override activo",
      value_unset: "(sin definir)",
      value_cleared: "(borrado)",
    },
    redis: {
      title: "Salud de Redis",
      reset: "Restablecer",
      page_title: "Salud de rate-limit y envío",
      subtitle: "Solo lectura · backend Fase 2 R1/R2 (memory / fake_redis) · customer_facing_allowed debe ser false",
      card_title: "Salud del backend de rate-limit",
      card_loading: "Cargando…",
      breach_banner: "customer_facing_allowed=true — contrato roto. STOP.",
      safe_banner: "customer_facing_allowed=false · solo interno",
      rate_limit_reset_title: "Reinicio de rate-limit",
      rate_limit_reset_subtitle: "Borra los buckets de rate-limit en memoria. Los buckets se reconstruyen en el siguiente escaneo. Es seguro llamarlo varias veces.",
      reset_buckets_btn: "Reiniciar buckets",
      reset_dialog_title: "Reiniciar buckets de rate-limit",
      reset_dialog_description: "Solo en memoria · sin escritura en DB · seguro de llamar varias veces · auditoría capturada en logs de supervisor.",
      reset_ok_at: "Reset OK · a {at}",
      full_snapshot: "Snapshot completo",
    },
    scan_audit: {
      title: "Resumen de auditoría de escaneo",
      subtitle: "Solo lectura · SIN PII · SIN token en bruto · SIN IP en bruto · ventanas 24h / 7d / total",
      loading: "Cargando agregados…",
      empty: "Aún no hay datos.",
      card_title: "Resumen de auditoría de escaneo",
      generated_at_label: "generated_at:",
      filters: {
        org_label: "Organización",
        kind_label: "Tipo",
        result_label: "Resultado",
        limit_label: "Límite Top-N",
        any_option: "(cualquiera)",
      },
      sections: {
        windows: "ventanas scan_audit",
        pre_lookup_windows: "ventanas de denegaciones pre-lookup",
        audit_flags_lifetime: "flags de auditoría (total)",
      },
      window_labels: {
        total: "total",
        last_7d: "7d",
        last_24h: "24h",
      },
      toplists: {
        by_result: "by_result",
        by_kind: "by_kind",
        top_scanners_opaque: "top_scanners (opaco)",
        top_organisation_ids: "top_organisation_ids",
        by_deny_reason_category: "by_deny_reason_category",
        pre_lookup_top_scanners: "top_scanners pre-lookup",
      },
    },
    legacy: {
      title: "Membresías legacy",
      tabs: {
        overview: "Resumen",
        classify: "Clasificar uno",
        batch: "Aplicar en lote",
      },
      apply_classify: "Aplicar clasificación",
      apply_batch: "Aplicar lote",
      run_report: "Informe de ejecución",
      page_title: "S9.1 Backfill de membresías legacy",
      subtitle: "Resumen con privacidad · clasificar uno (T2 HMAC) · aplicar en lote (T3 HMAC, tope 200 filas, cross-org protegido)",
      overview: {
        loading: "Cargando resumen…",
        card_title: "Membresías legacy",
        generated_at_label: "generated_at:",
        columns: {
          user_hash: "user_hash",
          status: "status",
          joined_at: "joined_at",
          source: "source",
          rl_promotion: "rl_promotion",
          role: "role",
        },
      },
      classify: {
        user_id_label: "ID de usuario",
        user_id_placeholder: "uuid",
        bucket_label: "Bucket",
        reason_label: "Motivo (opcional, guardado en auditoría)",
        role_label_backfill: "Rol (solo BACKFILL)",
        org_label_locked: "Organización (bloqueada al piloto)",
        shop_ids_label: "IDs de tienda (uno por línea, opcional)",
        footer_note: "BACKFILL: upsert idempotente de rl_promotion · SOFT_REVOKE: status→revoked + auditoría · EXCLUDE: marca solo en auditoría.",
        applied_line: "Aplicado · acción={action} · bucket={bucket}",
      },
      batch: {
        json_label: "JSON de lote (array de {shape} · tope {maxRows} filas)",
        parse_error_array: "La raíz debe ser un array JSON",
        parse_error_too_many: "Demasiadas filas ({n} > tope {max})",
        parse_error_json: "Error de parseo JSON: {msg}",
        row_error_not_object: "fila {i}: no es un objeto",
        row_error_user_id: "fila {i}: user_id ausente/inválido",
        row_error_bucket: "fila {i}: bucket debe ser BACKFILL | SOFT_REVOKE | EXCLUDE",
        row_error_cross_org: "fila {i}: BACKFILL cross-org no permitido (org={org})",
        row_error_count: "{count} error(es) de fila",
        row_more: "… y {count} más",
        preview_more: "… {count} filas más",
        dry_run_btn: "Dry-run del lote",
        applied_line: "Aplicado · run_id={run_id} · applied={applied} · failed={failed}",
        view_run_report: "Ver informe de ejecución →",
      },
      run_report_page: {
        back: "Volver a Legacy",
        loading: "Cargando…",
        page_title: "Informe de ejecución legacy",
        card_title: "Informe de ejecución",
        run_id_label: "run_id:",
        started_at_label: "started_at:",
        ended_at_label: "ended_at:",
        items_total_label: "items_total:",
        failures_header: "fallos ({count})",
        columns: {
          user_hash: "user_hash",
          error_code: "error_code",
        },
      },
    },
    retention: {
      title: "Retención",
      warning_affects_only: "Afecta sólo a {collection} · semántica delete_many · NO reversible",
      warning_real_purge: "La purga real borra filas en {collection} mediante delete_many. Sin restauración.",
      page_title: "Purgas de retención (T3)",
      page_subtitle_html: "Dry-run obligatorio · la ejecución real requiere confirm + motivo · {strong}",
      not_reversible: "NO reversible",
      qr_title: "Purga de retención de denegaciones pre-lookup QR",
      mock_title: "Purga de retención de bandeja simulada NP-R1",
      days_field_range_label: "{field} [{min},{max}]",
      dry_run_btn: "Dry-run",
      dry_run_result_title: "Dry-run · se eliminaría",
      irreversible_title: "Operación irreversible",
      reason_label_min3: "Motivo (mín. 3 caracteres)",
      apply_real_btn: "Aplicar purga real",
      purged_line: "Purgado · eliminados: {count}",
    },
    seed_helper: {
      title: "Asistente de seeds de membresía",
      no_applied_seed_run: "No se encontró ninguna ejecución de seed aplicada para {org}.",
      subtitle: "Solo lectura · deriva intenciones de promote del último seed piloto · solo Cargar-en-formulario-Promote por fila · Apply sigue requiriendo Dry-run + typed-confirm APPLY en S6.",
      reload_btn: "Recargar",
      defensive_note_label: "Nota defensiva:",
      defensive_note_body: "El paso Apply sigue pasando por dry-run S6 → typed-confirm APPLY. Sin apply masivo, sin creación de usuarios, sin mutación de membresías desde esta página.",
      filter_status_label: "Estado",
      filter_role_label: "Rol",
      seed_run_id_label: "seed_run_id:",
      seed_run_at_label: "seed_run_at:",
      loading: "cargando…",
      no_seed_run_msg: "No se encontró ninguna ejecución de seed aplicada para {org}. Ejecuta primero el seed piloto vía el endpoint admin de seed.",
      no_match_filters: "Ninguna intención coincide con los filtros actuales.",
      columns: {
        user_id: "user_id",
        proposed_role: "rol propuesto",
        shop_ids: "shop_ids",
        status: "estado",
        current: "actual",
        action: "acción",
      },
      row: {
        load_into_promote: "Cargar en Promote",
        copy_json: "JSON",
        synthetic_user_id_warning: "synthetic_user_id",
      },
    },
    audit: {
      promotion_lookup: "Búsqueda en auditoría de promociones",
      verify_membership: "Verificar membresía",
    },
  },

  roles: {
    admin: "Administrador",
    staff: "Personal interno",
    shop_manager: "Responsable de tienda",
    operator: "Operador",
    racket_technician: "Encordador / Técnico",
    head_coach: "Director técnico",
    customer: "Cliente",
    guardian: "Tutor o tutora",
    sponsor: "Patrocinador",
    unknown: "Rol desconocido",
  },

  token_kinds: {
    worker_personal: "Personal de trabajador",
    worker_self_open: "Auto-apertura de trabajador",
    customer_checkin: "Check-in de cliente",
    customer_handover: "Entrega a cliente",
    equipment: "Material",
    shop: "Tienda",
    ticket: "Ticket",
    event_checkin: "Check-in de evento",
    unknown: "Tipo desconocido",
  },

  ticket_status: {
    // RL-A.6 canonical (SS-1)
    draft: "Borrador",
    checked_in: "Recepcionado",
    assigned: "Asignado",
    in_progress: "En curso",
    pending_customer_approval: "Pendiente aprobación cliente",
    ready_for_pickup: "Listo para recoger",
    closed: "Cerrado",
    cancelled: "Cancelado",
    deleted: "Eliminado",
    // Legacy R3 / scaffolding
    received: "Recibido",
    ready: "Listo",
    handed_over: "Entregado",
    on_hold: "En pausa",
    requested: "Solicitado",
    accepted: "Aceptado",
    pickup: "Recogida",
    diagnosis: "Diagnóstico",
    pending_approval: "Pendiente de aprobación",
    approved: "Aprobado",
    delivered: "Entregado",
    unknown: "Estado desconocido",
  },

  ticket_actions: {
    check_in: "Check-in",
    assign_operator: "Asignar operador",
    assign_machine: "Asignar máquina",
    start: "Iniciar trabajo",
    request_approval: "Solicitar aprobación",
    mark_approved: "Marcar como aprobado",
    finish: "Finalizar",
    pickup: "Recoger",
    cancel: "Cancelar ticket",
    confirm_title: "¿{action}?",
    confirm_description: "Aplicar '{action}' al ticket {ticketId}. Se enviará al endpoint correspondiente.",
    terminal_state: "Estado terminal — sin más acciones.",
    current_status_label: "Estado actual",
    audit_timeline_title: "Línea de tiempo de auditoría",
  },

  envelope_status: {
    draft: "Borrador",
    queued: "En cola",
    dispatched: "Enviado",
    failed: "Fallido",
    cancelled: "Cancelado",
    unknown: "Estado desconocido",
  },

  membership_buckets: {
    backfill: "Backfill",
    soft_revoke: "Revocación blanda",
    exclude: "Excluir",
    unknown: "Bucket desconocido",
  },

  scan_audit: {
    granted: "Concedido",
    denied_role: "Denegado — rol",
    denied_rate_limit: "Denegado — límite de tasa",
    denied_revoked: "Denegado — revocado",
    denied_expired: "Denegado — expirado",
    denied_cross_org: "Denegado — cross-org",
    denied_cross_shop: "Denegado — cross-shop",
    denied_unknown: "Denegado — desconocido",
    metric_total: "Total de escaneos",
    metric_granted: "Concedidos",
    metric_denied: "Denegados",
    metric_window: "Ventana",
    metric_top_role: "Rol principal",
    metric_top_kind: "Tipo principal",
    metric_top_shop: "Tienda principal",
  },

  retention: {
    dry_run: "Simulación",
    apply: "Aplicar",
    not_reversible: "NO reversible",
    real_purge: "Purga real",
    no_restore: "Sin restauración",
    delete_many_semantics: "semántica delete_many",
    affects_only: "Afecta sólo a",
    cancel: "Cancelar",
    purge_now: "Purgar ahora",
    rows_purged: "Filas purgadas",
    rows_evaluated: "Filas evaluadas",
    cutoff_iso: "Corte (ISO)",
    select_collection: "Selecciona colección",
  },

  flag_states: {
    on: "Activado",
    off: "Desactivado",
    forced_on: "Forzado ACTIVADO",
    forced_off: "Forzado DESACTIVADO",
    unknown: "Desconocido",
  },

  dispatch: {
    provider_mock: "Proveedor simulado",
    dispatch_false: "Envío deshabilitado",
    dispatch_true: "Envío habilitado",
    q28_false: "Q28 deshabilitado",
    q28_true: "Q28 habilitado",
    read_only: "Sólo lectura",
    internal_only: "Sólo interno",
    flag_provider: "proveedor",
    flag_mock: "simulado",
    flag_dispatch: "envío",
    flag_q28: "q28",
    flag_mock_enabled: "simulado_activo",
    flag_dispatch_enabled: "envío_activo",
    flag_q28_enabled: "q28_activo",
    outbox_label: "bandeja",
    ttl_days_suffix: "ttl {days}d",
    error_prefix: "err {status}",
  },

  inventory: {
    page_header: "Inventario de cordajes y consumibles",
    subtitle: "Sólo admin · stock por tienda · movimientos auditables · sin hard-delete",
    new_btn: "Nuevo artículo",
    consumption_note: "Los tickets vinculados descuentan stock automáticamente al cerrarse (SS-6.1) · todo consumo es auditable y reversible con un movimiento compensatorio.",
    readonly_note: "Vista de sólo lectura: puedes consultar stock e histórico de movimientos; la gestión del stock corresponde a tu shop manager.",
    empty: "Todavía no hay artículos de inventario.",
    status_active: "activo",
    status_inactive: "inactivo",
    low_badge: "BAJO",
    low_source_shop: "tienda",
    low_source_shop_hint: "Umbral heredado del fallback por defecto de esta tienda (RACKET-LAB-ROLE-3).",
    toggle_title: "¿Cambiar el estado del artículo?",
    toggle_confirm: "Confirmar",
    filters: {
      shop: "Tienda",
      type: "Tipo",
      status: "Estado",
      all: "Todos",
      low_stock_only: "Sólo stock bajo",
    },
    form_catalog: {
      label: "Producto del catálogo (opcional)",
      placeholder: "— Seleccionar del catálogo central —",
      hint: "Autorrellena marca/modelo y guarda una referencia aditiva. La entrada manual sigue funcionando.",
    },
    columns: {
      shop: "Tienda",
      type: "Tipo",
      item: "Marca / modelo",
      stock: "Stock (disponible / inicial)",
      status: "Estado",
      actions: "Acciones",
    },
    types: {
      string_set: "Set de cordaje",
      string_reel: "Bobina de cordaje",
      consumable: "Consumible",
    },
    units: {
      set: "set(s)",
      meter: "m",
      unit: "unidad(es)",
    },
    actions: {
      adjust: "Ajustar",
      edit: "Editar",
      movements: "Histórico",
      activate: "Activar",
      deactivate: "Desactivar",
    },
    form: {
      title_create: "Nuevo artículo de inventario",
      title_edit: "Editar artículo de inventario",
      shop: "Tienda *",
      shop_placeholder: "Selecciona una tienda…",
      type: "Tipo *",
      brand: "Marca *",
      brand_placeholder: "p. ej. Babolat",
      model: "Modelo / cordaje *",
      model_placeholder: "p. ej. RPM Blast",
      gauge: "Calibre (opcional)",
      gauge_placeholder: "p. ej. 1,25mm / 17",
      unit: "Unidad",
      initial_quantity: "Cantidad inicial",
      consumption: "Consumo por ticket",
      consumption_hint: "Unidades descontadas automáticamente al cerrar un ticket vinculado (SS-6.1).",
      low_stock: "Umbral de stock bajo (opcional)",
      low_stock_hint: "Alerta (sólo UI) cuando el stock disponible cae a/bajo este valor. Sin notificaciones.",
      unit_cost: "Coste unitario (EUR, opcional)",
      unit_cost_hint: "Lo usa el informe mensual para estimar coste por tienda. Sin uso customer-facing.",
      notes: "Notas internas",
      anti_pii_hint: "Sin emails ni teléfonos · el backend rechaza '@' y 7+ dígitos.",
      cancel: "Cancelar",
      submit_create: "Crear artículo",
      submit_edit: "Guardar cambios",
      submitting: "Guardando…",
    },
    adjust: {
      title: "Ajustar stock",
      current: "Disponible actual",
      delta: "Ajuste (±) *",
      delta_hint: "Negativo descuenta · positivo añade. Reversible con un ajuste compensatorio — ambos quedan en la traza de auditoría.",
      reason: "Motivo *",
      reason_placeholder: "p. ej. corrección de recuento manual / compensación",
      insufficient: "El stock no puede quedar por debajo de cero.",
      cancel: "Cancelar",
      submit: "Aplicar ajuste",
      submitting: "Aplicando…",
    },
    movements: {
      title: "Movimientos de stock",
      empty: "Sin movimientos registrados.",
      close: "Cerrar",
      type_initial: "Inicial",
      type_manual_adjust: "Ajuste manual",
      type_consumption: "Consumo",
      compensate: "Compensar",
      compensated: "Compensado",
      columns: {
        at: "Fecha",
        type: "Tipo",
        delta: "Δ",
        range: "Antes → después",
        reason: "Motivo",
      },
    },
    report: {
      toggle: "Informe mensual",
      title: "Informe mensual de consumo",
      subtitle: "Sólo lectura · basado en movimientos de consumo auditables · universo QA excluido de los contadores operativos",
      loading: "Cargando informe…",
      all_shops: "Todas las tiendas",
      units_consumed: "Unidades consumidas",
      net_units: "Neto (tras compensaciones)",
      movements_count: "Movimientos de consumo",
      compensated: "Unidades compensadas",
      tickets_closed: "Tickets cerrados (operativos)",
      with_consumption: "Cerrados con consumo",
      coverage: "Cobertura",
      cost: "Coste estimado (EUR)",
      net_cost: "Coste neto (EUR)",
      missing_cost_note: "{n} artículo(s) consumidos sin coste unitario — las cifras en EUR son parciales.",
      qa_closed: "Tickets QA cerrados",
      qa_note: "Los tickets QA/test nunca consumen stock y se reportan por separado — NO se mezclan con los datos operativos.",
      top_items_title: "Artículos más consumidos",
      by_shop_title: "Por tienda",
      movements_title: "Movimientos de consumo (últimos)",
      ticket: "Ticket",
      empty: "Sin consumo registrado en este periodo.",
      months: {
        1: "Enero", 2: "Febrero", 3: "Marzo", 4: "Abril",
        5: "Mayo", 6: "Junio", 7: "Julio", 8: "Agosto",
        9: "Septiembre", 10: "Octubre", 11: "Noviembre", 12: "Diciembre",
      },
    },
  },

  banners: {
    track_a_pilot_preview: "Piloto Track A · Sólo Preview",
    pilot_only: "Superficie sólo para piloto",
    requires_admin: "Superficie sólo para administradores",
    pilot_mode_primary: "MODO PILOTO — TEAMSOFTWAREINNOVATIONS sólo interno",
    pilot_mode_secondary: "Sólo lectura · Sin customer-facing · Sin Q28 · Sin aplicar real",
    dispatch_real_enabled_stop: "ENVÍO REAL ACTIVADO · DETENER",
    dispatch_mock_only: "Sólo simulado · Q28 OFF · Sin llamada al proveedor",
  },
};

export default racketLabEs;
